import React from "react";
import { Button } from "antd";
import "./Button.css";

const CustomizeButton = ({ variant = "primary",className = "", children, onClick, style = {}, ...props  }) => {
  return (
    <Button
     onClick={onClick}
     className={`custom-btn ${variant} ${className}`}
      {...props}
      style={style}
    >
      {children}
    </Button>
  );
};

export default CustomizeButton;
